import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteFormTemplate = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}form_templates/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteFormTemplate;
